import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MaterializeAction } from 'angular2-materialize';
import { Subscription } from 'rxjs';
import { NgTable } from '../../coms';
import { AuthService } from '../../services/auth.service';
import { EmployeeId, EmployeeService } from '../../services/employee.service';
import { SecurityReport, SecurityReportService } from '../../services/security-report.service';
import { Utils } from '../../util';

@Component({
  selector: 'app-create-security-report',
  templateUrl: './create-security-report.component.html',
  styleUrls: ['./create-security-report.component.css']
})
export class CreateSecurityReportComponent implements OnInit, OnDestroy {

  subs: Subscription[] = [];

  form: FormGroup;

  pickadateParams = Utils.pickadateParams();
  pickatimeParams = Utils.pickatimeParams();

  constructor(
    private service: SecurityReportService,
    private employeeService: EmployeeService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
  ) {
    this.subs[0] = this.employeeService.getEmployees().subscribe(employees => {
      this.employees = {};
      this.rowsRead[0] = employees.map(employee => {
        employee.id = employee.id$;
        employee.name = `${employee.name} ${employee.lastName}`;
        this.employees[employee.id] = employee;
        return employee;
      });
    });
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      date: ['', Validators.required],
      time: ['', Validators.required],
    });
  }
  ngOnDestroy(){
    for(let sub of this.subs) sub.unsubscribe();
  }

  async onSubmit({ value, valid }: { value: any, valid: boolean }) {
    let securityReport: SecurityReport = {
      employeeId: this.selectedIds[0],
      employeeName: this.employees[this.selectedIds[0]].name,
      date: value.date,
      time: value.time,
      employees: [],
      userEmail: this.authService.currentUser.email,
    };

    let docRef = await this.service.addSecurityReport(securityReport);
    this.service.windowReplace.edit(docRef.id);
  }
  onCancel(){
    this.service.windowReplace.read();
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  readTable: NgTable;
  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  openModalRead(index: number) {
    this.currentReadIndex = index;
    this.readTable = new NgTable({columns: this.columnsRead[index], data: this.rowsRead[index], itemsPerPage: 5, onCellClick: this.selectRead.bind(this)});
  
    //this.onChangeTable(this.config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead(data: any): any{
    this.closeModalRead();
    this.selectedIds[this.currentReadIndex] = data.row.id;
  }
  unselectRead(){
    this.closeModalRead();
    this.selectedIds[this.currentReadIndex] = '';
  }

  selectedIds: string[] = [''];
  employees: {[id: string]: EmployeeId} = {};

  get readValid(){ return !!this.employees[this.selectedIds[0]] };
  currentReadIndex: number;
  rowsRead = [[]];
  columnsRead = [
    [//employee
      { title: 'Nombre', name: 'name' },
      { title: 'Folio', name: 'internalKey', sort: 'asc' },
      { title: 'Correo electrónico', name: 'email' }
    ],
  ];

}
